import { useState } from "react";
import "./InputField.scss";
import React from "react";

const InputField = React.forwardRef(({ label, type, placeholder, error, name, onChange, value }, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";

  const toggleVisibility = () => setShowPassword(!showPassword);

  return (
    <div className="input-field">
      <label className="input-field__label">{label}</label>
      <div className="input-field__wrapper">
        <input
          ref={ref}
          name={name}
          type={showPassword ? "text" : type}
          placeholder={placeholder}
          className={`input-field__input ${error ? "input-field__input--error" : ""}`}
          onChange={onChange}
          value={value}
        />
        {isPassword && (
          <button
            type="button"
            className="input-field__toggle"
            onClick={toggleVisibility}
            aria-label="Toggle password visibility"
          >
            <i className={`input-field__showbnt fa-regular ${showPassword ? "fa-face-glasses" : "fa-face-flushed"}`}></i>
          </button>
        )}
      </div>
      {error && (
        <div className="input-field__error">
          <i className="fa-solid fa-circle-xmark"></i>
          <span className="input-field__error--text">{error}</span>
        </div>
      )}
    </div>
  );
});

export default InputField;